<div class="col-md-12">
  <p>
    You are not authorized to view this page!
  </p>
</div>
